import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import AppleIcon from '@mui/icons-material/Apple';
import ShopIcon from '@mui/icons-material/Shop';
import logoSvg from '@/../logo.svg';

// Replace these with actual store URLs
const APP_STORE_URL = 'https://testflight.apple.com/join/hMeFa84T';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.flockcare.app';

interface MobileAppBannerProps {
  onDismiss: () => void;
}

export default function MobileAppBanner({ onDismiss }: MobileAppBannerProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: (t) => t.zIndex.appBar,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 1,
        backgroundColor: '#EFF6FF',
        borderBottom: '1px solid',
        borderColor: 'rgba(4, 102, 200, 0.15)',
      }}
    >
      {/* App icon */}
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '10px',
          backgroundColor: '#0466C8',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Box
          component="img"
          src={logoSvg}
          alt="Flock Care"
          sx={{ width: 28, height: 'auto', filter: 'brightness(0) invert(1)' }}
        />
      </Box>

      {/* Text */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.primary', lineHeight: 1.3 }}>
          Get the Flock Care app
        </Typography>
        <Typography sx={{ fontSize: 11, color: 'text.secondary', lineHeight: 1.3 }}>
          Available on iOS & Android
        </Typography>
      </Box>

      {/* Get button */}
      <Button
        variant="contained"
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          textTransform: 'none',
          fontWeight: 600,
          fontSize: 13,
          borderRadius: '16px',
          px: 2,
          minWidth: 0,
          flexShrink: 0,
        }}
      >
        Get
      </Button>

      {/* Close button */}
      <IconButton size="small" onClick={onDismiss} sx={{ flexShrink: 0, ml: -0.5 }}>
        <CloseIcon sx={{ fontSize: 18, color: 'text.disabled' }} />
      </IconButton>

      {/* Store menu */}
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={() => { setAnchorEl(null); window.open(APP_STORE_URL, '_blank'); }}
        >
          <ListItemIcon><AppleIcon fontSize="small" /></ListItemIcon>
          <ListItemText>TestFlight (iOS)</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => { setAnchorEl(null); window.open(PLAY_STORE_URL, '_blank'); }}
        >
          <ListItemIcon><ShopIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Google Play</ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
}
